export const GOVGR_LAYOUT_WRAPPER = "govgr-layout-wrapper";
export const GOVGR_LAYOUT_WRAPPER__FULL_HEIGHT =
  "govgr-layout-wrapper__full-height";
export const GOVGR_MODAL = "govgr-modal";
export const GOVGR_MODAL__OPEN = "govgr-modal__open";
export const GOVGR_MODAL__BODY = "govgr-modal__body";
export const GOVGR_MODAL__CONTENT = "govgr-modal__content";
export const GOVGR_MODAL__HEADING = "govgr-modal__heading";
export const GOVGR_MODAL__TEXT = "govgr-modal__text";
export const GOVGR_MODAL__ACTION = "govgr-modal__action";
export const GOVGR_BTN_PRIMARY = "govgr-btn-primary";
export const GOVGR_BTN = "govgr-btn";
export const GOVGR_LINK = "gov-link";
